import {
  Card,
  CardTitle,
  Button,
  Row,
  Col,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import subscriptionNames from "./subscriptionData";
import { getUser } from "../../service/AuthService";
import { Fragment, useMemo } from "react";

// --- helpers for expiry (date-only, inclusive) ---
function todayYMD() {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  const dd = String(now.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

function isExpired(expiryDate) {
  if (!expiryDate) return true; // no expiry = treat as not available
  // handle both "yyyy-mm-dd" and full ISO by slicing the date part
  const expYMD = expiryDate.slice(0, 10);
  const today = todayYMD();
  // expired only if expiry date is *before* today
  return expYMD < today;
}

const Cards = ({ creditsAvailable, expiryDate }) => {
  const user = getUser();
  const name = user?.name || "";
  const username = user?.username || "";
  const organization = user?.organization || "";
  const subscriptions = user?.subscriptions || "";
  const subscriptionList = subscriptions ? subscriptions.split(",") : [];
  const navigate = useNavigate();

  const expired = useMemo(() => isExpired(expiryDate), [expiryDate]);
  const noCredits = !creditsAvailable || creditsAvailable <= 0;

  // ✅ Cards are disabled if credits expired OR balance is 0 / missing
  const disabled = expired || noCredits;

  const subscribeHandler = () => navigate("/Contactus");
  const tutorialHandler = () => navigate("/Contactus");

  const cardHandler = (name) => {
    if (disabled) return;
    if (name === "AI Model Building") navigate("/ModelBuilder");
    if (name === "Product Pricing") navigate("/VendorPriceTable");
    if (name === "Behavior Analytics") navigate("/BehaviorAnalytics");
  };

  let displaySubscriptions = [...subscriptionNames];

  // Show Behavior Analytics only if org = techcomb AND subscriptionList includes it
  if (
    organization &&
    organization.toLowerCase() === "techcomb" &&
    subscriptionList.includes("Behavior Analytics")
  ) {
    if (!displaySubscriptions.includes("Behavior Analytics")) {
      displaySubscriptions.push("Behavior Analytics");
    }
  }

  return (
    <div>
      <Row className="mb-2">
        <Col xs="12">
          <h5 className="font-md-lg font-bold text-center">
            Your Active Subscriptions
          </h5>
        </Col>
      </Row>

      <Row className="g-4">
        {displaySubscriptions.map((name) => {
          const active = subscriptionList.includes(name);

          return (
            <Fragment key={name}>
              <Col md="6" lg="3">
                <Card
                  body
                  color={active ? "light-success" : "light-danger"}
                  style={{
                    cursor: active && !disabled ? "pointer" : "not-allowed",
                    opacity: disabled ? 0.5 : 1,
                  }}
                  onClick={() => cardHandler(name)}
                >
                  <CardTitle tag="h5">{name}</CardTitle>
                  <div>
                    {active ? (
                      <Button
                        disabled={disabled}
                        onClick={() => !disabled && tutorialHandler()}
                      >
                        {disabled ? "Not Available" : "View Tutorial"}
                      </Button>
                    ) : (
                      <Button
                        disabled={disabled}
                        onClick={() => !disabled && subscribeHandler()}
                      >
                        {disabled ? "Not Available" : "Subscribe Now"}
                      </Button>
                    )}
                  </div>
                </Card>
              </Col>
            </Fragment>
          );
        })}
      </Row>
    </div>
  );
};

export default Cards;
